module.exports = __webpack_public_path__ + "img/rect2.a573efae.png";